<template>
    <div>
        <q-tabs
            v-model="tab"
            inline-label
            active-color="input-color"
            indicator-color="primary"
            align="justify"
            class="bg-grey-2 text-grey shadow-2"
        >
            <q-tab name="incoming" icon="fa fa-arrow-alt-circle-down" :label="$t('transactions.menu.incoming')" v-if="this.$auth.can('transactions.incoming')"/>
            <q-tab name="on-ramp" icon="fa fa-arrow-alt-circle-down" :label="$t('transfers.on-ramp')" v-if="this.$auth.can('transactions.incoming')"/>
            <q-tab name="off-ramp" icon="fa fa-arrow-alt-circle-up" :label="$t('transfers.off-ramp')" v-if="this.$auth.can('transactions.outgoing')"/>
            <q-tab name="outgoing" icon="fa fa-arrow-alt-circle-up" :label="$t('transactions.menu.outgoing')" v-if="this.$auth.can('transactions.outgoing')"/>
            <q-tab name="user" icon="fa fa-user" :label="$t('transfers.table_titles.user')" v-if="this.$auth.can('users.list')"/>
        </q-tabs>

        <q-separator />

        <q-tab-panels v-model="tab" animated>
            <q-tab-panel name="incoming" v-if="this.$auth.can('transactions.incoming')">
                <incoming-transactions :transfer="transfer" @change="$emit('change')"/>
            </q-tab-panel>

            <q-tab-panel name="on-ramp" v-if="this.$auth.can('transfers.on-ramp')">
                <on-ramp :reference="transfer.reference" :status="transfer.status || ''"/>
            </q-tab-panel>

            <q-tab-panel name="off-ramp" v-if="this.$auth.can('transfers.off-ramp')">
                <off-ramp :reference="transfer.reference" :status="transfer.status || ''"/>
            </q-tab-panel>

            <q-tab-panel name="outgoing" v-if="this.$auth.can('transactions.outgoing')">
                <outgoing-transactions :transfer="transfer" @change="$emit('change')"/>
            </q-tab-panel>

            <q-tab-panel name="user" v-if="this.$auth.can('users.list')">
                <user-list :filter-by-email="transfer.user.email" />
            </q-tab-panel>
        </q-tab-panels>

    </div>
</template>
<script>
import OnRamp from './transfer-details/OnRamp'
import OffRamp from './transfer-details/OffRamp'

export default {
    name: "TransferDetails",
    props: {
        transfer: {
            type: Object,
            required: true
        }
    },
    computed: {},
    data() {
        return {
            tab: this.$auth.can('transactions.incoming') ? 'incoming' : 'outgoing'
        }
    },
    methods: {},
    created() {

    },
    mounted() {

    },
    components: {
        IncomingTransactions: () => import('Modules/Transaction/resources/pages/Incoming'),
        OutgoingTransactions: () => import('Modules/Transaction/resources/pages/Outgoing'),
        UserList: () => import('Modules/User/resources/pages/Index'),
        OnRamp,
        OffRamp
    },
}
</script>
<style>

</style>
